export const openApp = function(src) {
	// 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
	// 否则打开a标签的href链接
    var ifr = document.createElement('iframe');
    ifr.src = src;
    ifr.style.display = 'none';
    document.body.appendChild(ifr);
    window.setTimeout(function(){
        document.body.removeChild(ifr);
    },200);
}
/*判断是否是ios9以上*/
export const isIOS9=function() {
    //获取固件版本
    var getOsv = function () {
        var reg = /OS ((\d+_?){2,3})\s/;
        if (navigator.userAgent.match(/iPad/i) || navigator.platform.match(/iPad/i) || navigator.userAgent.match(/iP(hone|od)/i) || navigator.platform.match(/iP(hone|od)/i)) {
            var osv = reg.exec(navigator.userAgent);
            if (osv.length > 0) {
                return osv[0].replace('OS', '').replace('os', '').replace(/\s+/g, '').replace(/_/g, '.');
            }
        }
        return '';
    };
    var osv = getOsv();
    var osvArr = osv.split('.');
    //初始化显示ios9引导
    if (osvArr && osvArr.length > 0) {
        if (parseInt(osvArr[0]) >= 9) {
            return true
        }
    }
    return false
}
/**
   * 获取浏览器类型
   * @returns {*} 返回一个对象。【
   * ipad|iphoneOs|midp|uc|uc7|uc|android|ce|winphone 手机浏览器类型
   * ie5|ie6|ie7|ie8|ie9|ie10|ie11|moz|webkit|opera|safari PC浏览器类型
   * mob:是否手机端
   * pc:是否PC端
   * iosversion:IOS版本
   * 】
   */
export  const browser=function() {

	var _fn = function () {
		var ret = {};
		var sUserAgent = navigator.userAgent.toLowerCase();
		ret.ipad = sUserAgent.match(/ipad/i) == "ipad";
		ret.ipod = sUserAgent.match(/ipod/i) == "ipod";
		ret.iphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
		ret.midp = sUserAgent.match(/midp/i) == "midp";
		ret.uc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
		ret.uc = sUserAgent.match(/ucweb/i) == "ucweb";
		ret.qq = /qqbrowser/i.test(sUserAgent);
		ret.android = sUserAgent.match(/android/i) == "android";
		ret.is360 = /360 aphone browser/i.test(sUserAgent) || /360browser/i.test(sUserAgent);
		ret.chrome = /chrome/i.test(sUserAgent)
		ret.ce = sUserAgent.match(/windows ce/i) == "windows ce";
		ret.winphone = sUserAgent.match(/windows mobile/i) == "windows mobile";
		ret.isweixin = sUserAgent.match(/MicroMessenger/i) == "micromessenger";
		if (ret.ipad || ret.iphoneOs || ret.ipod) {
			ret.ios = true;
		}
		if (!(ret.ipad || ret.iphoneOs || ret.midp || ret.uc7 || ret.uc || ret.android || ret.ce || ret.winphone)) {
			return false;
		}
		else {
			if (navigator.userAgent.toLowerCase().match(/applewebkit\/([\d.]+)/).length > 1) {
				var _v = parseFloat(navigator.userAgent.toLowerCase().match(/applewebkit\/([\d.]+)/)[1]);
				_v = !isNaN(_v) ? _v : null;
				if (_v < 534 && !ret.uc) ret.isandroidbrowser = true;
			}
			return ret;
		}

	}

	var _iosfn = function () {
		var sUserAgent = navigator.userAgent.toLowerCase();
		var ret = null;
		var reg = /OS \d+_\d[_\d]* like Mac OS X/i;
		var vreg = /\d+/g;
		var iosstr = sUserAgent.match(reg);
		if (iosstr && iosstr.length) {
			var ver = iosstr[0].match(vreg)
			if (ver) {
				ver = ver.join(".");
				ret = ver;
			}
		}
		return ret;

	}

	var _android = function () {
		var sUserAgent = navigator.userAgent.toLowerCase();
		var ret = null;
		var reg = /android (\d+.)+\d/g;
		var vreg = /\d/g;
		var androidstr = sUserAgent.match(reg);
		if (androidstr && androidstr.length) {
			var ver = androidstr[0].match(vreg)
			if (ver) {
				ver = ver.join(".");
				ret = ver;
			}
		}
		return ret;
	}

	var _weixin_version = function () {
		var sUserAgent = navigator.userAgent.toLowerCase();
		var ret = null;
		var reg = /MicroMessenger\/([\d\.]+)/i;
		var str = sUserAgent.match(reg);
		if (str && str.length > 1) {
			str = str[1];
			ret = str;
		}
		return ret;
	}

	var _versionfn = function (str) {
		var _ret = 0;
		try {
			var _ver = parseFloat(navigator.userAgent.toLowerCase().match(str)[1]);
			if (isNaN(_ver)) _ret = 0;
			else _ret = _ver;
		} catch (e) {
			_ret = 0;
		}
		return _ret;
	}
	var ret = {}
	var _fna = function (obj) {
		obj = obj ? obj : {};
		if (obj.moz) return "Mozilla";
		if (obj.webkit) return "WebKit";
		if (obj.opera) return "Opera";
		if (obj.ie11) return "Internet Explorer 11";
		if (obj.ie10) return "Internet Explorer 10";
		if (obj.ie9) return "Internet Explorer 9";
		if (obj.ie8) return "Internet Explorer 8";
		if (obj.ie7) return "Internet Explorer 7";
		if (obj.ie6) return "Internet Explorer 6";
		if (obj.ie5) return "Internet Explorer 5";
		if (obj.ipad) return "Ipad";
		if (obj.iphoneOs) return "Iphone";
		if (obj.midp) return "Midp";
		if (obj.uc7 || obj.uc) return "Uc browser";
		if (obj.android) return "Android Browser";
		if (obj.cs) return "Window CE";
		if (obj.winphone) return "Window Moblie";
	}
	var mobile = _fn();
	if (mobile) {
		ret = mobile;

		ret.pc = false;
		ret.mob = true;
		ret.iosversion = _iosfn();
		ret.androidversion = _android();
		if (ret.isweixin) {
			ret.weixin_version = _weixin_version();
		}
	}else {
		var nav = navigator.userAgent.toLowerCase();
		var pc = {};
		pc.version = 0;
		pc.moz = /firefox/.test(nav);
		pc.webkit = /webkit/.test(nav);
		pc.opera = /opera/.test(nav);
		pc.safari = /safari/.test(nav);
		if (pc.moz) {
			pc.version = _versionfn(/firefox\/([\d.]+)/);
		}
		else if (pc.webkit) {
			pc.version = _versionfn(/chrome\/([\d.]+)/);
		}
		else if (pc.opera) {
			pc.version = _versionfn(/opera\/([\d.]+)/);
		}
		pc.ie = /msie/.test(nav);
		pc.ie11 = false;
		pc.ie10 = false;
		pc.ie9 = false;
		pc.ie8 = false;
		pc.ie7 = false;
		pc.ie6 = false;
		pc.ie5 = false;
		if (pc.ie) {
			var _ver = nav.match(/msie ([\d.]+)/)[1];

			if (_ver == "11.0") pc.ie11 = true;
			else if (_ver == "11.0") pc.ie11 = true;
			else if (_ver == "10.0") pc.ie10 = true;
			else if (_ver == "9.0") pc.ie9 = true;
			else if (_ver == "8.0") pc.ie8 = true;
			else if (_ver == "7.0") pc.ie7 = true;
			else if (_ver == "6.0") pc.ie6 = true;
			else pc.ie5 = true;
			var _vs = parseInt(_ver);
			if (!isNaN(_vs)) pc.version = _vs;
		}
		ret = pc;
		ret.mob = false;
		ret.pc = true;
		ret.version = pc.version;
	}
	ret.tostring = _fna(ret);
	return ret;
}